import {
  UserEntity,
  ComponentEntity,
  GroupEntity,
} from '@backstage/catalog-model';
import { JsonObject } from '@backstage/types';

/**
 * A relation from a user to their manager.
 * Reverse of RELATION_MANAGER_OF.
 */
export const RELATION_MANAGED_BY = 'managedBy';

/**
 * A relation from a manager to their direct report.
 * Reverse of RELATION_MANAGED_BY.
 */
export const RELATION_MANAGER_OF = 'managerOf';

/**
 * Extracts username from an email address (the part before @).
 * Returns the input as-is if it doesn't contain @.
 */
export function getUsernameFromEmail(email: string): string {
  return email.includes('@') ? email.substring(0, email.indexOf('@')) : email;
}

export type OktaTeamEntity = GroupEntity & {
  spec: GroupEntity['spec'] & {
    definition?: {
      path: string;
      moduleName: string;
    }
  }
};

export type OktaUserEntity = UserEntity & {
  spec: UserEntity['spec'] & {
    profile: {
      oktaID: string
      displayName: string
      email: string
      picture?: string
      division: string
      department: string
      cziEmployeeType: string
      cziProgram: string
      cziCompany: string
      cziJobFamily: string
      cziBackgroundCheckComplete: boolean
      githubUsername?: string
      githubUserId?: string
      manager?: string
      managerId?: string
      managerRef?: string
    }
    memberOf?: string[]
  }
};

export type OktaApplicationEntity = ComponentEntity & {
  spec: ComponentEntity['spec'] & {
    appName: string;
    groups: string[];
    path: string;
    accessibility?: JsonObject;
    visibility?: JsonObject;
    features?: string[];
    signOnMode?: string;
    credentials?: JsonObject;
    settings?: JsonObject;
  };
};

export type OktaAppPickerFormData = {
  application: string
  team: string
  isCustomTeam: boolean
  definition: string
  organization?: string
  parentTeams?: string[]
  authorizedUsers?: string[]
};
